export default __webpack_public_path__ + "static/6590-ae4185ebf60af607a1aeff8f69c3d28b.jpg";